import { render } from "./CustomAnimatedLogo.vue?vue&type=template&id=0bbc961d&scoped=true"
import script from "./CustomAnimatedLogo.vue?vue&type=script&lang=js"
export * from "./CustomAnimatedLogo.vue?vue&type=script&lang=js"

import "./CustomAnimatedLogo.vue?vue&type=style&index=0&id=0bbc961d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbc961d"]])

export default __exports__